import eaVisionLogo from './assets/ea-vision.svg';
import fieldViewLogo from './assets/field-view.svg';
import johnDeereLogo from './assets/john-deere.svg';
import quickBooksLogo from './assets/quickbooks.svg';

import type { Integration } from './types';

export const TEST_ID = 'connectionsPage';

export const TOAST_DURATION_MS = 3800;

export const INTEGRATIONS: Integration[] = [
    {
        brandClass: 'brandMarkJd',
        descriptionKey: 'johnDeereDescription',
        features: ['Fields', 'Boundaries', 'Machine data', 'Work records'],
        iconSrc: johnDeereLogo,
        id: 'jd',
        isLive: true,
        kindKey: 'johnDeereKind',
        name: 'John Deere Operations Center',
        wordmark: ['JOHN', 'DEERE']
    },
    {
        brandClass: 'brandMarkCfv',
        descriptionKey: 'climateDescription',
        features: ['As-planted', 'As-applied', 'Yield', 'Rx zones'],
        iconSrc: fieldViewLogo,
        id: 'cfv',
        isLive: false,
        kindKey: 'climateKind',
        name: 'Climate FieldView',
        statusLabelKey: 'comingQ3',
        wordmark: ['FIELD', 'VIEW']
    },
    {
        brandClass: 'brandMarkQb',
        descriptionKey: 'quickBooksDescription',
        features: ['Customers', 'Invoices', 'Classes', 'Items'],
        iconSrc: quickBooksLogo,
        id: 'qb',
        isLive: false,
        kindKey: 'quickBooksKind',
        name: 'QuickBooks Online',
        statusLabelKey: 'comingQ3',
        wordmark: ['QB']
    },
    {
        brandClass: 'brandMarkDji',
        descriptionKey: 'djiDescription',
        features: ['Flight logs', 'Swath', 'Telemetry'],
        id: 'dji',
        isLive: false,
        kindKey: 'djiKind',
        name: 'DJI Agras',
        statusLabelKey: 'comingQ4',
        wordmark: ['DJI']
    },
    {
        brandClass: 'brandMarkXag',
        descriptionKey: 'xagDescription',
        features: ['Missions', 'Nozzles', 'Chemicals'],
        id: 'xag',
        isLive: false,
        kindKey: 'xagKind',
        name: 'XAG Cloud',
        statusLabelKey: 'comingQ4',
        wordmark: ['XAG']
    },
    {
        brandClass: 'brandMarkEav',
        descriptionKey: 'eavDescription',
        features: ['Missions', 'Coverage', 'Orchards'],
        iconSrc: eaVisionLogo,
        id: 'eav',
        isLive: false,
        kindKey: 'eavKind',
        name: 'EAVision',
        statusLabelKey: 'comingQ4',
        wordmark: ['EA', 'VISION']
    }
];
